<template>
  <div>
    <div class="modal" v-bind:class="[isShow === true ? 'is-active' : '']">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span>添付ファイルの確認</span>
          </p>
          <button class="delete" aria-label="close" id="close" @click="close_modal"></button>
        </header>
        <section class="modal-card-body">
            <div v-for="img in files" v-bind:key="img.id">
              <div class="preview-item">
                <img
                  class="preview-item-file"
                  :src="img.path"
                  alt=""
                />
              </div>
            </div>
        </section>
        <footer class="modal-card-foot">
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data:function (){
    return {
      isShow:false
    }
  },
  props:{
    files: {
      type: Object,
      default: null,
    },
  },
  methods:{
    close_modal(){
      this.isShow = false
    },
    show(){
      this.isShow = true
    }
  }
}
</script>